import { Box, Typography } from "@mui/material";

export default function ItemThumbnail({ src, size, hideIfEmpty = false }) {
  if (!src && hideIfEmpty) {
    return null;
  }

  if (src) {
    return (
      <Box
        component="img"
        src={src}
        alt=""
        sx={{
          width: size,
          height: size,
          objectFit: "contain",
          borderRadius: 1,
          flexShrink: 0,
          bgcolor: "background.default",
          border: "1px solid",
          borderColor: "divider",
        }}
      />
    );
  }

  return (
    <Box
      sx={{
        width: size,
        height: size,
        flexShrink: 0,
        borderRadius: 1,
        border: "1px solid",
        borderColor: "divider",
        bgcolor: "background.default",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Typography variant="caption" sx={{ color: "text.disabled", textAlign: "center", lineHeight: 1.2 }}>
        No Image
      </Typography>
    </Box>
  );
}
